export const USERDATAADDRESS_CREATE_RESET = 'USERDATAADDRESS_CREATE_RESET'
export const USERDATAADDRESS_CREATE_SET_CREATED = 'USERDATAADDRESS_CREATE_SET_CREATED'
export const USERDATAADDRESS_CREATE_SET_ERROR = 'USERDATAADDRESS_CREATE_SET_ERROR'
export const USERDATAADDRESS_CREATE_SET_VIOLATIONS = 'USERDATAADDRESS_CREATE_SET_VIOLATIONS'
export const USERDATAADDRESS_CREATE_TOGGLE_LOADING = 'USERDATAADDRESS_CREATE_TOGGLE_LOADING'
